<template>
  <div ref="wrapper">

    <form id="form-ozn__form" method="post" ref="form" action @submit="submit" autocomplete="off" v-if="!successOpen">
      <h2>
        <small v-if="steps > 1">Krok {{step}} / {{steps}}</small>
        <br v-if="steps > 1" />
        <span v-if="!form.title">Pomocniczy formularz zgłoszeniowy</span>
        <span v-if="form.title">{{form.title}}</span>
      </h2>

      <p>*) Pole wymagane</p>

      <h3>Informacje o podróży</h3>

      <ic-form-row-horizontal
        new_id="type"
        aria="Pole jest wymagane"
        label="Podróż odbywam"
        :labelWidth="4"
        :controlWidth="6"
        :error="hasError('form.type')"
        :required="isRequired('form.type')"
        
      >
       <!-- <IcRadioGroup
          id="type"
          v-model="form.type"
          :options="formTypesRadio"
          :v="$v.form.type"
         
        ></IcRadioGroup> -->
        <ic-select
          id="type"
          v-model="form.type"
          :values="formTypes"
          :v="$v.form.type"
          :searchable="true"
          :allowEmpty="false"
          placeholder='... (wybierz jedną z dwóch opcji)'
        ></ic-select>

      </ic-form-row-horizontal>

      <ic-form-row-horizontal
        new_id="bsoNo"
        aria="Pole jest wymagane"
        label="Nr wniosku"
        v-if="form.type == 'group'"
        :labelWidth="4"
        :controlWidth="6"
        :error="hasError('form.bsoNo')"
        :required="isRequired('form.bsoNo')"
      >
        <ic-input id="bsoNo" v-model="form.bsoNo" :v="$v.form.bsoNo"></ic-input>
      </ic-form-row-horizontal>

      <div v-if="requireBSO">
        <ic-form-row-horizontal
          new_id="participants"
          aria="Pole jest wymagane"
          label="Towarzyszami podróży są"
          :labelWidth="4"
          :controlWidth="6"
          :error="hasError('form.participants')"
          :required="isRequired('form.participants')"
        >
        <ic-checkbox-group id="participants" v-model="form.participants" :options="participantTypes" :v="$v.form.participants" @input="onParticipantsSelected"></ic-checkbox-group> 

        <!-- <ic-select
          id="participants"
          v-model="form.participants"
          :values="participantTypes"
          :v="$v.form.participants"
          :searchable="true"
          :allowEmpty="false"
          :multiple="true"
          @input="onParticipantsSelected"
          placeholder='... (wybierz jedną lub kilka opcji)'

        ></ic-select> -->

        </ic-form-row-horizontal>

        <ic-form-row-horizontal
          new_id="persons"
          aria="Pole jest wymagane"
          label="Liczba osób towarzyszących"
          :labelWidth="4"
          :controlWidth="6"
          :error="hasError('form.persons')"
          v-if="hasParticipants"
          :required="isRequired('form.persons')"
        >
          <ic-input id="persons" v-model="form.persons" type="number"></ic-input>
        </ic-form-row-horizontal>

        <h3>Forma kontaktu</h3>

        <ic-form-row-horizontal
          new_id="reply_via"
          aria="Pole jest wymagane"
          label="Forma odpowiedzi"
          :labelWidth="4"
          :controlWidth="6"
          :error="hasError('form.reply_via')"
          :required="isRequired('form.reply_via')"
        >
          <ic-select-system
            id="reply_via"

            v-model="form.reply_via"
            :values="replyTypes"
            :allowEmpty="false"
            :v="$v.form.reply_via"
            placeholder='... (wybierz jedną z dwóch opcji)'
          ></ic-select-system>
        </ic-form-row-horizontal>

        <div v-if="form.reply_via">
          <ic-form-row-horizontal
            new_id="email"
            aria="Pole jest wymagane"
            label="E-mail"
            v-if="form.reply_via === 'email'"
            :labelWidth="4"
            :controlWidth="6"
            :error="hasError('form.email')"
            :required="isRequired('form.email')"
          >
            <ic-input id="email" v-model="form.email" :v="$v.form.email" @keydown="preventPaste"></ic-input>
          </ic-form-row-horizontal>

          <ic-form-row-horizontal
            new_id="email_confirm"
            aria="Pole jest wymagane"
            label="Potwierdzenie e-mail"
            v-if="form.reply_via === 'email'"
            :labelWidth="4"
            :controlWidth="6"
            :error="hasError('form.email_confirm')"
            :required="isRequired('form.email_confirm')"
          >
            <ic-input
              id="email_confirm"
              v-model="form.email_confirm"
              @keydown="preventPaste"
              :v="$v.form.email_confirm"
            ></ic-input>
          </ic-form-row-horizontal>
        </div>

        <ic-form-row-horizontal
          new_id="phone"
          aria="Pole jest wymagane"
          label="Telefon kontaktowy"
          :labelWidth="4"
          :controlWidth="6"
          :error="hasError('form.phone')"
          :required="isRequired('form.phone')"
        >
          <!-- <ic-input id="phone" v-model="form.phone" :v="$v.form.phone"></ic-input> -->
          <ic-input-phone id="phone" v-model="form.phone" :v="$v.form.phone" maxlength="0"></ic-input-phone>
        </ic-form-row-horizontal>

        <h3>Informacje dotyczące podróży</h3>

        <ic-form-ozn-connection
          v-model="form.connections"
          :v="$v"
          :hasError="hasError"
          :isRequired="isRequired"
        ></ic-form-ozn-connection>

        <h3
          style="font-size: 28px;"
        >Informacje dotyczące niepełnosprawności lub ograniczeń w poruszaniu się</h3>

        <ic-form-ozn-disability
          v-model="form.disabilities"
          :participants="form.participants"
          :v="$v"
          :hasError="hasError"
          @update:persons="form.persons = $event"
          @update:disabled_persons="form.disabled_persons = $event"
          :isRequired="isRequired"
        ></ic-form-ozn-disability>

        <div class="mtm">
          <ic-form-row-horizontal2
            new_id="disabled_persons"
            label="Liczba osób potrzebujących pomocy"
            :labelWidth="5"
            :controlWidth="2"
          >
            <div id="disabled_persons" class="form-control form-control-static">{{disabled_persons}}</div>
          </ic-form-row-horizontal2>
          <ic-form-row-horizontal2
            new_id="total_persons"
            label="Łączna liczba osób"
            :labelWidth="5"
            :controlWidth="2"
          >
            <div id="total_persons" class="form-control form-control-static">{{total_persons}}</div>
          </ic-form-row-horizontal2>
        </div>

        <h3>Zakres pomocy</h3>

        <ic-form-ozn-assistance
          v-model="form.assistance"
          :v="$v"
          :hasError="hasError"
          :isRequired="isRequired"
        ></ic-form-ozn-assistance>

        <h3>Informacje dodatkowe</h3>

        <ic-form-row-horizontal2
          new_id="remarks"
          label="Uwagi"
          :labelWidth="4"
          :controlWidth="8"
          aaaerror="hasError('form.remarks')"
        >
          <ic-textarea v-model="form.remarks" id="remarks"></ic-textarea>
        </ic-form-row-horizontal2>

        <!-- <h3>Zgoda na przetwarzanie</h3>

        <div class="form-group" :class="{'has-error': hasError('form.agreement')}">
          <ic-checkbox id="agreement" v-model="form.agreement" :val="1" :v="$v.form.agreement">
            <span v-html="$t('rodo_agreement')"></span>
          </ic-checkbox>
          <div class="form-control-description">
            <small>{{hasError('form.agreement')}}</small>
          </div>
        </div>-->

        <hr />

        <div class="form-group">
          <p>Po zatwierdzeniu zgłoszenia przyciskiem „Wyślij”, zostanie ono przekazane do rozpatrzenia oraz będzie dostępna opcja zapisania zgłoszenia w pliku PDF na urządzeniu.</p>
        </div>

        <div class="form-group">
          <!-- <button v-if="hasErrors()" disabled class="btn btn-primary" style="background-color: #efcacb; color: #ed1c24">
            Proszę poprawić błędy
          </button>-->
          <button :disabled="submitting" vvv-if="!hasErrors()" class="btn btn-primary">
            <span v-if="submitting">Proszę czekać</span>
            <span v-if="!submitting">Wyślij</span>
          </button>
          <vue-loading
            v-show="submitting"
            type="spin"
            color="#0071BC"
            :size="{ width: '50px', height: '50px' }"
          ></vue-loading>
        </div>
      </div>
    </form>
    <p>
      <small>
        Tę stronę chroni rozwiązanie reCAPTCHA. Obowiązuje <a href="https://policies.google.com/privacy" target="_blank">Polityka Prywatności</a> 
        oraz <a href="https://policies.google.com/terms" target="_blank">Regulamin</a> Google. 
      </small>
    </p>



  <div  aria-live="assertive"> 

<!-- Modal -->
<div class="modal fade" id="tyModal" tabindex="-1" aria-labelledby="thankYouModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">


      <div v-if="step == steps">
        <div v-if="steps == 1">
          <h3 class="text-center">Dziękujemy za zgłoszenie.</h3>
          <p>
            Zostało ono przekazane do odpowiedniej jednostki merytorycznej w celu rozpatrzenia. Zgłoszenie zostało zarejestrowane pod numerem
            <strong
              v-if="forms.length"
            >#{{forms[0].form_number}}</strong> , podczas kontaktu z nami prosimy powołać się na ten numer.
            <br />
          </p>
        </div>

        <div v-if="steps > 1">
          <h3 class="text-center">Dziękujemy za zgłoszenia.</h3>
          <p>
            Zostały one przekazane do odpowiedniej jednostki merytorycznej w celu rozpatrzenia. Zgłoszenia zostały zarejestrowane pod numerami
            
            <span
              v-for="(form,idx) in forms" :key="idx"
            >
              <strong>
                <i v-if="idx>0">,</i>
                #{{form.form_number}}
              </strong>
            </span>, podczas kontaktu z nami prosimy powołać się na te numery.
          </p>
        </div>
        <p>
          Uprzejmie informujemy, że wysłanie zgłoszenia nie jest równoznaczne z decyzją o zrealizowaniu pomocy.
          <br />Prosimy czekać na odpowiedź ze strony Przewoźnika.
        </p>
      </div>

      <div v-if="step < steps" class="text-center" aria-live="assertive">
        <h3>Formularz został zapisany.</h3>
        <p>Proszę przejść do następnego kroku...</p>
      </div>

      </div>
      <div class="modal-footer">
        <div v-if="step == steps">
          <a type="button"
            v-if="forms[0] && steps == 1"
            :href="forms[0].pdfUrl"
            class="btn btn-primary btn-sm pull-left"
            target="_blank"
          >Pobierz PDF</a>
          <a type="button"
            v-if="forms[0] && steps > 1"
            :href="forms[0].pdfUrl"
            class="btn btn-primary btn-sm pull-left"
            target="_blank"
          >Pobierz PDF "tam"</a>
          <a type="button"
            v-if="forms[1] && steps > 1"
            :href="forms[1].pdfUrl"
            class="btn btn-primary btn-sm pull-left"
            target="_blank"
          >Pobierz PDF "z powrotem"</a>
        </div>
        <a type="button"
          :href="pdfUrl"
          class="btn btn-primary pull-right btn-sm"
          target="_blank"
          v-if="step < steps"
          @click.prevent="nextStep"
        >Następny krok</a>
        <a type="button"
          :href="pdfUrl"
          class="btn btn-primary pull-right btn-sm"
          target="_blank"
          v-if="step == steps"
          @click.prevent="finish"
        >Zamknij</a>
      </div>
    </div>
  </div>
</div>

  </div>

  </div>
</template>

<script>
import Vue from "vue";
import IcFormRowHorizontal from "@/components/ic-common/form/helpers/FormRowHorizontal.vue";
import IcFormRowHorizontal2 from "@/components/ic-common/form/helpers/FormRowHorizontal2.vue";
import IcSelect from "@/components/ic-common/form/controls/Select.vue";
import IcSelectSystem from "@/components/ic-common/form/controls/SelectControl.vue";
import IcInput from "@/components/ic-common/form/controls/Input.vue";
import IcInputPhone from "@/components/ic-common/form/controls/InputPhone.vue";
import IcFormOznConnection from "./FormOznConnection.vue";
import IcFormOznDisability from "./FormOznDisability.vue";
import IcFormOznAssistance from "./FormOznAssistance.vue";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox.vue";
import IcCheckboxGroup from "@/components/ic-common/form/controls/CheckboxGroup.vue";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup.vue";
import IcTextarea from "@/components/ic-common/form/controls/Textarea.vue";
import { participantTypes, formTypes, replyTypes, formTypesRadio } from "./storage";
import validations from "./validations.js";
// import oznmessages from './lang'
import get from "lodash/get";
import unset from "lodash/unset";
import forEach from "lodash/forEach";
import keys from "lodash/keys";
import axios from "axios";
import { objToFormData } from "@/ic-common/helpers/objToFormData";
import { VueLoading } from "vue-loading-template";
import { preventPaste, scrollTo } from "@/ic-common/helpers/utils";
import {
  iFrameSendMessage,
  iFrameAnnounceHeight,
  isIframe
} from "@/ic-common/helpers/iframe";

// import {addMessages, i18n} from '@/ic-common/i18n/i18n-setup'
// import TreeView from "vue-json-tree-view"

// Vue.use(TreeView)

// addMessages(i18n.locale, oznmessages[i18n.locale])

const _ = { get, forEach, keys, unset };

class postMessage {
  constructor(data) {
    this.init();
    Object.assign(this, data);
  }

  reset() {
    this.init();
  }

  init() {
    
    this.isSent = false;
    this.hasError = false;
    this.hasValidationError = false;
    this.carrier = "";
  }
}

export default {
  name: "IcFormOzn",
  props: {
      value: {
        type: Object,
        default: []
      },
    step: {
      type: Number,
      default: 1
    },
    steps: {
      type: Number,
      default: 1
    }
  },
  validations,
  // i18n,
  // i18n: {
  //   messages: oznmessages
  // },
  data() {
    return {
      forms: [],
      form: {},
      pdfUrl: "",
      submitting: false,
      errors: {
        form: {}
      },
      participantTypes: participantTypes,
      formTypes: formTypes,
      replyTypes: replyTypes,
      successOpen: false,
      modal: null,
      formHeight: 0
    };
  },
  computed: {
    requireBSO() {
      return (
        this.form.type &&
        (this.form.type !== "group" ||
          (this.form.type == "group" &&
            this.form.bsoNo &&
            !this.$v.form.bsoNo.$error))
      );
    },
    hasParticipants() {
      return (
        this.form.participants.length > 0 &&
        (this.form.participants.indexOf("carer") != -1 ||
          this.form.participants.indexOf("guide") != -1 ||
          this.form.participants.indexOf("other") != -1)
      );
    },
    disabled_persons: {
      get() {
        let count = 0;
        this.form.disabilities.forEach(item => {
          let persons = parseInt(item.persons);
          return !isNaN(persons) ? (count += persons) : count;
        });
        return count;
      },
      set() {}
    },
    total_persons: {
      get() {
        let disabled_persons = isNaN(parseInt(this.disabled_persons))
          ? 0
          : parseInt(this.disabled_persons);
        let persons = isNaN(parseInt(this.form.persons))
          ? 0
          : parseInt(this.form.persons);
        return disabled_persons + persons;
      }
    }
  },
  mounted() {
    this.reset();
    setInterval(() => this.announceHeight(), 2000);
   this.modal = new bootstrap.Modal(document.getElementById('tyModal'), {})

  },
  updated() {
    this.announceHeight();
  },
  watch: {
    form: {
      handler: function(newValue, oldValue) {
        this.$emit("input", this.form);
        this.announceHeight();
      },
      deep: true
    },
    "form.participants": function(newValue, oldValue) {
      //console.log(newValue);
      if (newValue.indexOf("carer") == -1) {
        this.form.persons = 0;
      }
      // if (newValue.indexOf("na") !== -1) {
      //   this.form.participants = this.form.participants.filter((a)=> a == 'na')
      // }
    },
    "form.connections": {
      handler: function(newValue, oldValue) {
        let carrier = this.form.connections[0]
          ? this.form.connections[0].carrier
          : "";
        if (carrier) {
          for (let i = 0; i < this.form.connections.length; i++) {
            if (this.form.connections[i].carrier == "PKP INTERCITY S.A.") {
              carrier = "PKP INTERCITY S.A.";
            }
          }
          iFrameSendMessage(new postMessage({ carrier }));
        }
      },
      deep: true
    }
  },
  methods: {
    announceHeight() {
      let f = this.$refs.form;
      if (f && f.scrollHeight && f.scrollHeight !== this.formHeight) {
        this.$nextTick(() => iFrameAnnounceHeight(f, 30));
        this.formHeight = f.scrollHeight;
      }
    },
    reset() {
      this.form = Object.assign(
        {
          type: "individual",
          bsoNo: "",
          participants: [],
          reply_via: "",
          email: "",
          email_confirm: "",
          phone: "",
          connections: [],
          persons: "",
          disabilities: [],
          assistance: {
            atStation: [],
            atStationRemarks: "",
            inTrain: [],
            baggage: [],
            baggage_size: "",
            meetingPlace: "",
            meetingPlaceOther: "",
            meetingPlaceCashNo: ""
          },
          remarks: "",
          agreement: ""
        },
        this.value
      );
      this.$emit("input", this.form);
    },
    isRequired(field) {
      let v = _.get(this.$v, field.replace("[", ".$each["));
      // to jest bardzo źle, ale v.required zwraca false, jeśli jest pole puste
      return v.$params.required ? true : v.$params.requiredIf ? true : false;
    },
    hasError(field) {
      //console.log(this.$v,field.replace("[", ".$each["));
      let clientSide = _.get(this.$v, field.replace("[", ".$each["));
      let serverSide = _.get(this.errors, field);
      let message = "";
      //console.log("{CLI1EBNT SIDE",clientSide)
      if (clientSide && clientSide.$error) {
        // _.unset(this.errors,field);
        _.forEach(clientSide, (item, key) => {
          
          if (key[0] !== "$" && item === false) {
            let localMessageKey =
              "validation_" +
              field.replace("form.", "").replace(/\[[0-9]+\]/, "");
            let specificMessageKey = localMessageKey + "_" + key;
            let globalMessageKey = "validation_" + key;
            let params = clientSide.$params[key];

            message = this.$te(specificMessageKey)
              ? this.$t(specificMessageKey)
              : this.$te(localMessageKey)
              ? this.$t(localMessageKey)
              : this.$t(globalMessageKey);

            return message;
          }
        });
      } else if (serverSide) {
        message = serverSide;
      }

      if (clientSide && clientSide.$dirty && !clientSide.$error) {
        _.unset(this.errors, field);
        message = "";
      }

      return message;
    },
    setErrors(errors) {
      this.errors.form = errors;
    },
    hasErrors() {
      return this.$v.$anyError || _.keys(this.errors.form).length > 0;
    },
    getErrors(){
      let errors = {};

      
      for (let [key, value] of Object.entries(this.$v.form.$model)) {
        ////console.log(`${key}: ${value}`);
        if(key && this.$v.form[key] && this.$v.form[key].$anyError){
          ////console.log(this.$v.form[key], this.hasError(key));
        }
        
      
      }


      return errors;
    },
    openM(){
        this.modal.show();
       this.successOpen = true;
    },
    submit(e) {
      e.preventDefault();
      this.$v.$touch();

      let hasErrors = this.hasErrors();
      ////console.log(this.errors);
      //console.log(this.getErrors());
      this.errors.form = [];
      if (!hasErrors) {
        this.submitting = true;

        // let data = new FormData(this.form);
        // objToFormData(data,this.form);

        axios({
          // data: data,
          data: this.form,
          method: "post",
          responseType: "json",
          url: (window.outsidemodx?"assets/form-store/?action=store":
            
            "/ax26hrxl857-a/components/icformozn/connector.php?action=store")
        }).then(msg => {
          if (msg.data.success) {
            msg.data.object.form_number = msg.data.object.formNumber;
            this.forms.push(msg.data.object);
            this.successOpen = true;
            this.modal.show();
            this.reset();
            this.$v.$reset();
            this.$nextTick(() =>
              this.scrollTo(document.getElementById("form-ozn__form"))
            );

            iFrameSendMessage(new postMessage({ isSent: true }));
          } else {
            this.$v.$reset();
            this.setErrors(msg.data.object);
            setTimeout(
              () => this.scrollTo(document.querySelector(".has-error")),
              400
            );
            iFrameSendMessage(new postMessage({ hasError: true }));
          }
          this.submitting = false;
        });
      } else {
        setTimeout(
          () => {this.scrollTo(document.querySelector(".has-error"))
                  document.querySelector(".has-error input").focus();
                },
          400
        );
        iFrameSendMessage(new postMessage({ hasValidationError: true }));
      }
      return false;
    },
    nextStep() {
      this.successOpen = false;
      this.modal.hide();
      this.reset();
      this.$emit("form:saved", this.form);
    },
    finish() {
      window.location.href = window.location.origin + window.location.pathname;
    },
    sent() {
        this.successOpen = true;
        this.modal.show();
    },
    onParticipantsSelected(value) {
      if (value && value.length) {
        value.forEach(item => {
          if (item === 'na') {
            this.form.participants = ['na']
          }
        })
      }
    },
    preventPaste,
    scrollTo
  },
  components: {
    IcFormRowHorizontal,
    IcFormRowHorizontal2,
    IcSelect,
    
    IcInput,
    IcInputPhone,
    IcFormOznConnection,
    IcFormOznDisability,
    IcFormOznAssistance,
    IcCheckbox,
    IcCheckboxGroup,
    IcRadioGroup,
    IcTextarea,
    IcSelectSystem,
    VueLoading,
    // TreeView
  }
};
</script>

<style lang="scss">
.grecaptcha-badge { visibility: hidden; }

$col-ic-highcontrast-text: #fff200;
#form-ozn__form {
  h3 {
    margin: 30px 0;
  }
  .form-group.has-error label, .has-error p {
    color: #ed1c24;
  }
  .form-group.has-error label.error, .form-group.has-error p.error {
    font-size: 0.8em;
  }
  legend {
    margin: 0;
  }
  .form-control-static {
    background: transparent;
    border-color: transparent;
  }
  .form-control-description:before {
    display: none;
  }
  label.is-required:after {
    content: "*";
    vertical-align: sup;
  }
  .vue-loading {
    display: inline-block;
    margin-left: 10px !important;
    width: 33px !important;
    height: 33px !important;
    vertical-align: middle;
  }
  .btn-sm {
    padding: 0 20px;
    font-size: 18px;
  }
}
#high-contrast {
  #form-ozn__form {
    fieldset.well {
      border-color: $col-ic-highcontrast-text;
    }
    fieldset.well legend {
      background: #000;
      color: $col-ic-highcontrast-text;
    }
    fieldset.well legend .btn {
      background: $col-ic-highcontrast-text;
      color: black;
    }
  }
}

.has-error label.error {
  p {
    margin: 10px 0;
  }
  ul {
    padding-left: 20px;
  }
}
</style>
